import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=2d692575&scoped=true&"
import script from "./Center.vue?vue&type=script&lang=js&"
export * from "./Center.vue?vue&type=script&lang=js&"
import style0 from "./Center.vue?vue&type=style&index=0&id=2d692575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d692575",
  null
  
)

export default component.exports